<body>
            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3"> 

                    <div class="row justify-content-center">
                        <h6>Purchase Report</h6> 
                    </div>
      
                    <!-- Tabele row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
                     <div class="card-body">

                       <div class="row pb-2">
                        <div class="col-3 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="fromDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="From Date">
                              </div>
                          </div>
                        <div class="col-3 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                              </div>
                        </div>
                        <div class="col-3 input-group">
                            <select [ngClass]="{'dark-bg' : isDark }" class="custom-select" [(ngModel)]="selectSupplier" id="inputGroupSelect02">
                                <option [ngValue]="null">All</option>
                                <option *ngFor="let item of supplierList" [value]="item.SupName"> {{item.SupName}}</option> 
                              </select>
                          </div>
                        <div class="3">
                            <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                            <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                        </div>
                    </div>

                      <div class="col-12 table-responsive" id="purchaseReport">
                        <table class="table" [ngClass]="{'dark-bg' : isDark }">
                          <thead>
                          <tr >                          
                            <th>Date</th>
                            <th>BillNo</th>
                            <th>Type</th>
                            <th>Supplier</th>  
                            <th>ItemCode</th>         
                            <th>Description</th>      
                            <th>CreatedBy</th>                           
                            <th class="text-right">UnitPrice</th>                         
                            <th class="text-right">Qty</th>
                            <th class="text-right">Unit</th>
                            <th class="text-right">Amount</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let item of filteredPurchaseList">    
                            <td>{{item.GrnDate | date :'y-MM-dd'}}</td>
                            <td>{{item.GrnNo}}</td>
                            <td>{{item.Type}}</td>
                            <td>{{item.SupName}}</td>  
                            <td>{{item.ItemCode}}</td>  
                            <td>{{item.Description}}</td>  
                            <td>{{item.CreatedBy}}</td>  
                            <td class="text-right">{{item.UnitPrice |  number:'1.2-2'}}</td>  
                            <td class="text-right">{{item.Qty}}</td>  
                            <td>{{item.Unit}}</td>                        
                            <td class="text-right">{{item.Amount |  number:'1.2-2'}}</td>                                                                                  
                          </tr>  
                          <tr class="table-active">
                            <td colspan="7" class="text-right text-bold">Total Qty :</td>
                            <td class="text-bold">{{getTotalQty()}}</td>
                            <td colspan="2" class="text-right text-bold">Total Cost :</td>
                            <td class="text-right text-bold">{{getTotalCost() | number:'1.2-2'}}</td>
                          </tr>                                              
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
      
                    <!-- this row will not appear when printing -->
                    <div class="row no-print">
                      <div class="col-12">
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
                      </div>
                    </div>


                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->        
 </body>






